import React from "react";

import { Switch, Route } from "react-router-dom";

import Footer from "Common/Footer";
import PartnerProvider from "Common/PartnerProvider";
import ResponsiveTopBar from "Common/TopBar/ResponsiveTopBar";

import EmailInUse from "./errorApp/EmailInUse";

export const baseURL = "/intuit/error";

const ErrorApp = () => (
  <PartnerProvider>
    <ResponsiveTopBar branding="intuit" />
    <Switch>
      <Route path={`${baseURL}/email-in-use`} children={<EmailInUse />} />
    </Switch>
    <Footer />
  </PartnerProvider>
);

export default ErrorApp;
